module.exports = __webpack_public_path__ + "static/media/Lesson-6-18-Dealing-with-my-Anger.0b099b3c.pdf";